<template>
    <div>
        <modal :showDialog="activeModal == 'PRIORITY-CHART'" @close="closeModal" :title="$t('Graph')">
            <sci-chart-single-day-priority-alarms :allAlarmTypes="allAlarmTypes.filter(x => parseInt(x.priority) == data.column.field.charAt(data.column.field.length - 1)).map(x => x.description)" :dataset="chart" :systemId="data.id" :activeSet="0" :devices="devices" :initialZoomOut="true" :sid="1" :day="day" :priority="data.column.field.charAt(data.column.field.length - 1)"></sci-chart-single-day-priority-alarms>
        </modal>
        <div v-if="value == 0 && data.column.field != 'visits'" style="margin: 5px">
            <img src="@/assets/img/tenor.gif"/>
        </div>
        <div v-else-if="data.column.field == 'visits'" class="pl-4 pt-2 pd-2 pr-4">
            <p >{{$t('Visits')}}: {{obj}}</p>
        </div>
        <div v-else style="width: 85vw; height: 80vh">
            <sci-chart-one-line-alarms v-if="apiMethodName != 'getSystemAlarmFromToday'" style="margin-left: 2.5vw;" :dataset="obj" :initialZoomOut="true" :sid="1" :day="day" :name="data.column.field"></sci-chart-one-line-alarms>
            <div :class="apiMethodName != 'getSystemAlarmFromToday' ? 'height-120' : 'height-80'" style="display: flex; flex-direction: column; flex: 1;">
                <ejs-grid ref="system_modal_grid" height="100%" width="100%" :toolbar="apiMethodName != 'getSystemAlarmFromToday' ? null : toolbar" :toolbarClick="toolbarClick" :selectionSettings="selectionOptions" :allowTextWrap="true" :textWrapSettings="wrapSettings" :dataBound="dataBound" :dataSource="obj" :allowPaging="true" :pageSettings="pageSettings" :allowFiltering="true" :filterSettings="filterOptions" :allowSorting="true" :allowMultiSorting='true' :allowPdfExport='true' :allowCsvExport='true' :allowExcelExport='true' :showBusyIndicator="true" style="position: relative">
                    <e-columns>
                        <e-column field="number" :headerText="$t('Unit')" textAlign="Left" :customAttributes="customAttributes"></e-column>
                        <e-column field="type" :headerText="$t('Type')" textAlign="Left" :customAttributes="customAttributes"></e-column>
                        <e-column field="alarmType" :headerText="$t('AlarmType')" textAlign="Left" :customAttributes="customAttributes"></e-column>
                        <e-column field="createDate" :headerText="$t('CreateDate')" textAlign="Left" :customAttributes="customAttributes" :filter="filterMenu" type="datetime" :format="dateTimeFormatOptions"></e-column>
                        <e-column field="endDate" :headerText="$t('EndDate')" textAlign="Left" :customAttributes="customAttributes" :filter="filterMenu" type="datetime" :format="dateTimeFormatOptions"></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
        </div>
    </div>

</template>

<script>
import { getSystemAlarmFromDay, getAllAlarmTypes, getAlarmsByIdAndDay, getDeviceAlarmFromDay,getAlarmsForDetailsModal, getSystemAlarmChartsForDay } from '@/api/api'
import { GridPlugin, Sort, Page, Filter, Toolbar, Search, CommandColumn, PdfExport, ExcelExport } from "@syncfusion/ej2-vue-grids";
import Modal from '../Modal.vue';
import SciChart from '../SciChart.vue';
import SciChartMultiple from '../SciChartMultiple.vue';
import SciChartSingleDayPriorityAlarms from '../Charts/SciChartSingleDayPriorityAlarms.vue';
import SciChartOneLineAlarms from '../Charts/SciChartOneLineAlarms.vue'

export default {
    components: {
        Modal,
        SciChart,
        SciChartMultiple,
        SciChartSingleDayPriorityAlarms,
        SciChartOneLineAlarms
    },
    provide:{ 
        grid: [ Sort, Page, Filter, Toolbar, Search, CommandColumn, PdfExport, ExcelExport],
    },
    props: {
        data: {
            type: Object,
            required: true
        },
        day: {
            type: Number,
            required: false,
            default: 0
        },
        apiMethodName: {
            type: String,
            required: true
        },
        value: {
            type: Number
        }
    },
    data() {
        return {
            obj: [],
            chart: [],
            devices: 0,
            activeModal: null,
            graphData: {
                xValues: [],
                yValues: []
            },
            filterMenu: {
                type: "Menu"
            },
            statusChartData: [],
            allAlarmTypes: [],

            toolbar: [
                { text: this.$t('ShowGraph'), id: 'show-graph', prefixIcon: "ChartIcon", align: 'Right',},
			],
            pageSettings: { pageSize: 100, pageSizes: [10, 25, 50, 100] },
            wrapSettings: { wrapMode: "Content" },
            selectionOptions: { type: "Multiple" },
            filterOptions: {
              type: "CheckBox",
            },
            dateTimeFormatOptions: { format: 'yyyy-MM-dd HH:mm:ss', type:'dateTime'},
            customAttributes: { class: "customcss" },
        }
    },
    methods: {
        async getData() {           
            var field = this.data.column.field

            switch(this.apiMethodName){
                case 'getSystemAlarmFromToday':
                    this.loadAlarmTypes()

                    this.obj = await getSystemAlarmFromDay(this.data.id, field.charAt(field.length - 1), this.day)
                    var result = await getSystemAlarmChartsForDay(this.data.id, field.charAt(field.length - 1), this.day);

                    if(result.alarms.length != result.numberOfDevices && result.alarms.length != 0) {
                        var availableDevices = result.alarms.map(x => x.item2)
                        for(let i = 1; i <= result.numberOfDevices; i++){
                            if(!availableDevices.includes(i.toString())){
                                result.alarms.push({item1: [], item2: i.toString()})
                            }
                        }
                    }

                    this.chart.push(result.alarms)
                    this.devices = result.numberOfDevices
                    break;
                case 'getAlarmsByIdAndDay':
                    this.obj = await getAlarmsByIdAndDay(this.data.id, this.day)
                    break;
                case 'getAlarmsForDetailsModal':
                    this.obj = await getAlarmsForDetailsModal(this.data.alarmTypeId, this.data.systemId, this.data.deviceId, this.day)
                    break;
                case 'getDeviceAlarmFromDay':
                    this.obj = await getDeviceAlarmFromDay(this.data.id, field, this.day)
                    break;
                case 'getVisitsForDay':
                    this.obj = this.data[this.data.column.field][this.day];
                    break;
            }

            for(let i = 0; i < this.obj.length; i++){
                this.obj[i]['createDate'] = new Date(this.obj[i]['createDate'].toDateTime())  
                this.obj[i]['endDate'] = new Date(this.obj[i]['endDate'].toDateTime())  
                this.obj[i]['alarmType'] = this.$t(this.obj[i]['alarmType'])
            }
        },
        async loadAlarmTypes () {
            var aT = await getAllAlarmTypes()
            this.allAlarmTypes = aT;
        },
        dataBound: function () {
			this.$refs.system_modal_grid.autoFitColumns();
		},
        toolbarClick: function (args) {
			switch (args.item.id) {
                case "show-graph":
                    if(this.apiMethodName == "getSystemAlarmFromToday" || this.data.column.field == "errorLogs"){
                        this.activeModal = "PRIORITY-CHART"
                        return;
                    }
                    break;
			}
		},
        closeModal() {
            this.activeModal = null;
            this.graphData = {
                xValues: [],
                yValues: []
            };
        }
    },
    mounted: async function() {
        this.getData()
    }
}
</script>

<style>
.ChartIcon::before {
    content: url("~@/assets/img/Systems/GraphsBlack.svg");
}
</style>

<style scoped>
.height-120 {
    height: calc(80vh - 120px);
}

.height-80 {
    height: 80vh;
}
</style>



// WEBPACK FOOTER //
// src/components/Systems/SystemAlarmsDetailsModal.vue